import React from 'react'
import commonStyles from "../../Shared/commonStyles.module.css";
import offeringStyles from "./Offering.module.css";
import { Link } from 'react-router-dom';

function Offering() {
  return (
    <section className={commonStyles.section}>
      <div className={commonStyles.container}>
        <span className={commonStyles.eyebrow}>What We Offer</span>
        <h2>Flexible gifting support for every type of buyer</h2>
        <div className={offeringStyles["cards-4"]}>
          <article className={offeringStyles.card}>
            <h3>Ready-Made Hampers</h3>
            <p>Curated hampers for key occasions when you need something beautiful quickly.</p>
            <Link className={commonStyles.btnLink} to="/occasions">Shop Hampers</Link>
          </article>
          <article className={offeringStyles.card}>
            <h3>Personalised Gifts</h3>
            <p>Embroider names, messages, or designs to create something truly personalised.</p>
            <Link className={commonStyles.btnLink} to="/customer-services/Personalisation">Explore Personalisation</Link>
          </article>
          <article className={offeringStyles.card}>
            <h3>Bespoke Hampers</h3>
            <p>Tailored gifting based on recipient, occasion, budget, and delivery timing.</p>
            <Link className={commonStyles.btnLink} to="/customer-services/Contact">Contact us</Link>
          </article>          
        </div>
      </div>
    </section>
  )
}

export default Offering